import { useMobile } from "@/hooks";
import { LeftArrow, Modal } from "@monsterindia/global-ui-components";
import React from "react";

type ModalProps = {
  showModal: boolean;
  closeModal: () => void;
  isMobile?: boolean;
  screenAlignment?: "right" | "center" | "bottom-sheet";
  children: React.ReactNode;
  heading: string;
  rightIcon?: React.ReactNode;
  bodyHeightAuto?: boolean;
};

const ModalWithHeaderFooter = ({
  children,
  showModal,
  closeModal,
  heading,
  rightIcon,
  bodyHeightAuto,
}: ModalProps) => {
  const isMobile = useMobile();
  return (
    <>
      <Modal
        showModal={showModal}
        closeModal={closeModal}
        screenAlignment={isMobile ? "bottom-sheet" : "right"}
        showCloseButton={true}
        showHandleBar={true}
        customClass="!px-0 !py-2"
      >
        <div>
          <div className="px-3 py-2 text-base font-bold md:!py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {!isMobile && (
                  <div onClick={closeModal}>
                    <LeftArrow className="size-5 cursor-pointer" />
                  </div>
                )}
                <div className="font-semibold">{heading}</div>
              </div>
              <div className={`${isMobile ? "mr-9" : ""}`}>{rightIcon}</div>
            </div>
          </div>
          <div className="bg-border-moderate h-[1px] w-full"></div>
          <div>
            <div
              className={`${bodyHeightAuto ? "" : "min-h-[30rem]"} overflow-y-scroll p-5 md:!overflow-y-hidden`}
            >
              {children}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalWithHeaderFooter;
